import {
  PostAddToCartApiArg,
  PostAddToCartApiResponse,
  CartResponse,
  GetCartApiArg,
  GetCartApiResponse,
} from '@/services/ecomm/types';

import { api } from '../api';

import { EClientError } from './error';

export const eCommApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCart: builder.query<GetCartApiResponse, GetCartApiArg>({
      query: () => '/ecomm/cart',
      providesTags: ['Cart'],
      transformResponse: (response: CartResponse) => {
        const { cartView } = response;

        return cartView;
      },
    }),

    addCart: builder.mutation<PostAddToCartApiResponse, PostAddToCartApiArg>({
      query: (post) => ({
        url: '/ecomm/add-to-cart',
        method: 'POST',
        body: post,
      }),

      invalidatesTags: ['Cart', 'Rewards'],

      transformResponse: (result: CartResponse) => {
        if (!result.isSuccess) {
          const message = result.messageException ?? undefined;
          throw new EClientError(message);
        } else {
          return result.cartView;
        }
      },
    }),
  }),
});

export const { useGetCartQuery, useAddCartMutation } = eCommApi;
